<!-- =========================================
     SANGEETHA TOYS — CONTACT PAGE
========================================= -->

<app-navbar-style-two></app-navbar-style-two>

<!-- ── PAGE HERO BANNER ── -->
<section class="contact-hero">
  <div class="contact-hero__bg" aria-hidden="true">
    <span class="hero-bubble b1" aria-hidden="true"></span>
    <span class="hero-bubble b2" aria-hidden="true"></span>
    <span class="hero-bubble b3" aria-hidden="true"></span>
    <span class="hero-emoji e1" aria-hidden="true">🧸</span>
    <span class="hero-emoji e2" aria-hidden="true">🚀</span>
    <span class="hero-emoji e3" aria-hidden="true">⭐</span>
    <span class="hero-emoji e4" aria-hidden="true">🎨</span>
  </div>

  <div class="container contact-banner">
    <div class="contact-hero__content" *ngFor="let Content of projectsContent;">
      <span class="hero-eyebrow">🌟 Get In Touch</span>
      <h1 class="hero-title">{{ Content.title }}</h1>
      <p class="hero-desc">{{ Content.paragraph }}</p>

      <!-- Quick trust pills -->
      <div class="hero-pills" aria-hidden="true">
        <span class="hero-pill"><i class='bx bx-check-shield'></i> Safe & Trusted</span>
        <span class="hero-pill"><i class='bx bx-time'></i> Quick Response</span>
        <span class="hero-pill"><i class='bx bxs-star'></i> 4.9 Rated</span>
      </div>
    </div>
  </div>

  <!-- Wave bottom -->
  <div class="hero-wave" aria-hidden="true">
    <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0,40 C480,80 960,0 1440,40 L1440,80 L0,80 Z" fill="#f0f6ff"/>
    </svg>
  </div>
</section>

<!-- ── MAIN CONTACT SECTION ── -->
<section class="contact-main">
  <div class="container">

    <!-- Top info strip -->
    <!-- <div class="info-strip">
      <div class="info-strip__item">
        <div class="info-strip__icon"><i class='bx bx-map'></i></div>
        <div>
          <strong>Our Address</strong>
          <span>123, Main Road, Coimbatore, Tamil Nadu</span>
        </div>
      </div>
      <div class="info-strip__item">
        <div class="info-strip__icon"><i class='bx bx-phone'></i></div>
        <div>
          <strong>Call Us</strong>
          <span><a href="tel:+919876543210">+91 98765 43210</a></span>
        </div>
      </div>
      <div class="info-strip__item">
        <div class="info-strip__icon"><i class='bx bx-envelope'></i></div>
        <div>
          <strong>Email Us</strong>
          <span><a href="mailto:info@sangeethatoys.com">info&#64;sangeethatoys.com</a></span>
        </div>
      </div>
      <div class="info-strip__item">
        <div class="info-strip__icon"><i class='bx bx-time-five'></i></div>
        <div>
          <strong>Working Hours</strong>
          <span>Mon – Sat: 9 AM – 8 PM</span>
        </div>
      </div>
    </div> -->

    <!-- Two-column layout -->
    <div class="contact-grid">

      <!-- ── LEFT: FORM ── -->
      <div class="contact-form-card">

        <div class="form-card__header">
          <span class="form-eyebrow">✉️ Send a Message</span>
          <h2>We'd Love To Hear<br>From You!</h2>
          <p>Got a question about a toy or an order? Fill the form and our team will get back to you shortly.</p>
        </div>

        <form [formGroup]="contactForm" class="contact-form" novalidate>
          <div class="row g-3">

            <!-- Name -->
            <div class="col-sm-6">
              <div class="cf-group">
                <label for="name">
                  <i class='bx bx-user'></i> Your Name <span class="req">*</span>
                </label>
                <input formControlName="lead_name"
                       class="cf-input"
                       id="name"
                       type="text"
                       placeholder="Enter your name">
                <div class="cf-error"
                     *ngIf="contactForm.get('lead_name')?.invalid && contactForm.get('lead_name')?.touched">
                  Name is required.
                </div>
              </div>
            </div>

            <!-- Phone -->
            <div class="col-sm-6">
              <div class="cf-group">
                <label for="phone">
                  <i class='bx bx-phone'></i> Phone <span class="req">*</span>
                </label>
                <input formControlName="contact_phone"
                       class="cf-input"
                       id="phone"
                       type="tel"
                       placeholder="10-digit number"
                       maxlength="10">
                <div class="cf-error"
                     *ngIf="contactForm.get('contact_phone')?.invalid && (contactForm.get('contact_phone')?.dirty || contactForm.get('contact_phone')?.touched)">
                  <ng-container *ngIf="contactForm.get('contact_phone')?.errors?.required">Phone is required.</ng-container>
                  <ng-container *ngIf="contactForm.get('contact_phone')?.errors?.pattern">Enter a valid number.</ng-container>
                  <ng-container *ngIf="contactForm.get('contact_phone')?.errors?.minlength">
                    Min {{ contactForm.get('contact_phone')?.errors?.minlength?.requiredLength }} digits.
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="col-sm-6">
              <div class="cf-group">
                <label for="email">
                  <i class='bx bx-envelope'></i> Email
                </label>
                <input formControlName="contact_email"
                       class="cf-input"
                       id="email"
                       type="email"
                       placeholder="your@email.com">
                <div class="cf-error"
                     *ngIf="contactForm.get('contact_email')?.invalid && (contactForm.get('contact_email')?.dirty || contactForm.get('contact_email')?.touched)">
                  <ng-container *ngIf="contactForm.get('contact_email')?.errors?.pattern">Enter a valid email.</ng-container>
                </div>
              </div>
            </div>

            <!-- Customer Type -->
            <div class="col-sm-6">
              <div class="cf-group">
                <label for="tileType">
                  <i class='bx bx-category'></i> Customer Type <span class="req">*</span>
                </label>
                <select formControlName="customer_type" class="cf-input cf-select" id="tileType">
                  <option value="" disabled>Select type</option>
                  <option value="44">Architects / Interior</option>
                  <option value="45">Builders / Contractors</option>
                  <option value="46">Others / Retail</option>
                </select>
                <div class="cf-error"
                     *ngIf="contactForm.get('customer_type')?.invalid && contactForm.get('customer_type')?.touched">
                  Customer type is required.
                </div>
              </div>
            </div>

            <!-- Location -->
            <div class="col-sm-6">
              <div class="cf-group">
                <label for="location">
                  <i class='bx bx-map-pin'></i> Location <span class="req">*</span>
                </label>
                <input formControlName="delivery_location"
                       class="cf-input"
                       id="location"
                       type="text"
                       placeholder="Your city / area">
                <div class="cf-error"
                     *ngIf="contactForm.get('delivery_location')?.invalid && contactForm.get('delivery_location')?.touched">
                  Location is required.
                </div>
              </div>
            </div>

            <!-- Message -->
            <div class="col-12">
              <div class="cf-group">
                <label for="description">
                  <i class='bx bx-message-detail'></i> Message
                </label>
                <textarea formControlName="scope_of_project"
                          class="cf-input cf-textarea"
                          id="description"
                          rows="4"
                          placeholder="Tell us what you're looking for…"></textarea>
              </div>
            </div>

          </div><!-- /row -->

          <!-- Submit -->
          <button type="button"
                  class="cf-submit"
                  (click)="submitContactForm()"
                  [disabled]="isLoading"
                  [class.loading]="isLoading">
            <ng-container *ngIf="!isLoading; else loadingTpl">
              <i class='bx bxs-paper-plane'></i>
              Send Message
            </ng-container>
            <ng-template #loadingTpl>
              <i class="bx bx-loader-alt bx-spin"></i>
              Sending…
            </ng-template>
          </button>

        </form>

      </div><!-- /form card -->

      <!-- ── RIGHT: INFO + MAP MINI ── -->
      <div class="contact-info-col">

        <!-- Info cards -->
        <div class="ci-card">
          <div class="ci-card__icon ci-card__icon--blue">
            <i class='bx bx-map'></i>
          </div>
          <div class="ci-card__body">
            <h4>Our Address</h4>
            <p>123, Main Road,<br>Coimbatore, Tamil Nadu – 641001</p>
          </div>
        </div>

        <div class="ci-card">
          <div class="ci-card__icon ci-card__icon--green">
            <i class='bx bx-phone-call'></i>
          </div>
          <div class="ci-card__body">
            <h4>Call Us</h4>
            <p><a href="tel:+919876543210">+91 98765 43210</a></p>
            <p class="ci-card__sub">We're available Mon–Sat, 9 AM – 8 PM</p>
          </div>
        </div>

        <div class="ci-card">
          <div class="ci-card__icon ci-card__icon--orange">
            <i class='bx bx-envelope'></i>
          </div>
          <div class="ci-card__body">
            <h4>Email Us</h4>
            <p><a href="mailto:info@sangeethatoys.com">info&#64;sangeethatoys.com</a></p>
            <p class="ci-card__sub">We reply within 24 hours</p>
          </div>
        </div>

        <div class="ci-card">
          <div class="ci-card__icon ci-card__icon--purple">
            <i class='bx bx-time-five'></i>
          </div>
          <div class="ci-card__body">
            <h4>Working Hours</h4>
            <p>Mon – Sat: 9:00 AM – 8:00 PM</p>
            <p class="ci-card__sub">Sunday: 10:00 AM – 6:00 PM</p>
          </div>
        </div>

        <!-- Social row -->
        <div class="ci-social">
          <span class="ci-social__label">Follow Us</span>
          <a href="https://www.facebook.com/" target="_blank" class="ci-social__btn ci-social__btn--fb" aria-label="Facebook">
            <i class='bx bxl-facebook'></i>
          </a>
          <a href="https://www.instagram.com/" target="_blank" class="ci-social__btn ci-social__btn--ig" aria-label="Instagram">
            <i class='bx bxl-instagram'></i>
          </a>
          <a href="https://wa.me/" target="_blank" class="ci-social__btn ci-social__btn--wa" aria-label="WhatsApp">
            <i class='bx bxl-whatsapp'></i>
          </a>
          <a href="https://www.youtube.com/" target="_blank" class="ci-social__btn ci-social__btn--yt" aria-label="YouTube">
            <i class='bx bxl-youtube'></i>
          </a>
        </div>

      </div><!-- /info col -->

    </div><!-- /contact-grid -->

  </div>
</section>

<!-- ── MAP ── -->
<section class="map-section">
  <div class="map-section__header">
    <div class="map-pill">
      <i class='bx bx-map-pin'></i>
      <div>
        <strong>Visit Sangeetha Toys</strong>
        <small>Come explore our toy world in store!</small>
      </div>
    </div>
  </div>

  <!-- <div class="map-section__frame">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.9236!2d51.4041436!3d25.1239247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e45d185e218ade3%3A0x427bb2de01ae0abf!2sUnion%20Fire%20Protection!5e0!3m2!1sen!2sin!4v0000000000000"
      width="100%"
      height="420"
      style="border:0;"
      allowfullscreen=""
      loading="lazy"
      title="Store location map">
    </iframe>
  </div> -->

  <div class="map-section__frame">
    <iframe
        src="https://maps.google.com/maps?q=Perungudi,%20Chennai,%20Tamil%20Nadu&t=&z=15&ie=UTF8&iwloc=&output=embed"
        width="100%"
        height="420"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        title="Store location map">
    </iframe>
</div>
</section>
